import { Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  useStyles,
  ContentTooltiptAnalyticsCurriculum
} from '../../../../../Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip'
import { useSelector } from 'react-redux'

const LcCard = ({ lc, color, curriculum }) => {
  const classes = useStyles()
  const currentCurriculum = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum || curriculum || {}
  )

  return (
    <Tooltip
      title={<ContentTooltiptAnalyticsCurriculum lc={lc} currentCurriculum={currentCurriculum} />}
      arrow
      classes={{ tooltip: classes.customWidthGuttmanChart }}
    >
      <FontAwesomeIcon size='lg' icon={'circle'} color={color || 'grey'} />
    </Tooltip>
  )
}

export default LcCard
